export class Empresa {
    codigo: string;
    codigo_sha: string;
    razon_social: string;
}

export interface EmpresaResponse {
    data: Empresa;
    detail: string;
    error:any[]
}

export interface EmpresasResponse {
    data: Empresa[];
    detail: string;
    error:any[]
}
